'use client'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import ProductBadge from './product-badge'
export type { PriceType } from './product-badge'
import type { Props } from './product-badge'

export default function Container(props: Omit<Props, 'text'>) {
  const { translate } = useTranslations()
  const text = {
    blackFriday: translate('Black_Friday'),
    newLowerPrice: translate('NewLowerPrice'),
    limitedBatch: translate('LimitedBatch'),
    isBidPrice: translate('Product_IsBidPrice'),
    newBadge: translate('Badge_New'),
    topSeller: translate('Badge_TopSeller'),
    recommended: translate('Badge_Recommended'),
  }
  return <ProductBadge text={text} {...props} />
}
